import { Component } from '@angular/core';
import { MatCard } from '@angular/material/card';

@Component({
    selector: 'pin-skeleton-card',
    templateUrl: './accounts-list-skeleton-card.component.html',
    styleUrls: ['./accounts-list-skeleton-card.component.scss'],
    imports: [MatCard]
})
export class SkeletonCardComponent {
}
